import { gql, useQuery } from '@apollo/client';

import Entity from '../../components/entity';

import type {
  GetAllFinancialAccountsQuery,
  GetAllFinancialAccountsQueryVariables,
} from './__generated__/useFinancialAccounts.gql';

export const FINANCIAL_ACCOUNT_FRAGMENT = gql`
  fragment FinancialAccountFields on FinancialAccount {
    id
    name
    type
    subtype
    mask
    ...EntityAvatar
    bankConnection {
      id
      lastSyncedAt
      historicalSyncComplete
      hasPotentialSyncIssue
      unhealthyConnectionCallout {
        id
        metadata
      }
    }
    bank {
      id
      name
    }
    currentBalance {
      id
      balance
      creditLimit
      timestamp
    }
  }
  ${Entity.Avatar.Fragment}
`;

export const GET_ALL_FINANCIAL_ACCOUNTS = gql`
  query GetAllFinancialAccounts {
    getFinancialAccountsForUser {
      ...FinancialAccountFields
    }
  }
  ${FINANCIAL_ACCOUNT_FRAGMENT}
`;

export type FinancialAccount = GetAllFinancialAccountsQuery['getFinancialAccountsForUser'][number];

export const useFinancialAccounts = () => {
  const { data, loading, error } = useQuery<GetAllFinancialAccountsQuery, GetAllFinancialAccountsQueryVariables>(
    GET_ALL_FINANCIAL_ACCOUNTS
  );

  return { financialAccounts: data?.getFinancialAccountsForUser ?? [], loading, error };
};
